import { render, staticRenderFns } from "./AccountInfoBoxes.vue?vue&type=template&id=5af6197e&scoped=true&"
import script from "./AccountInfoBoxes.vue?vue&type=script&lang=js&"
export * from "./AccountInfoBoxes.vue?vue&type=script&lang=js&"
import style0 from "./AccountInfoBoxes.vue?vue&type=style&index=0&id=5af6197e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af6197e",
  null
  
)

export default component.exports